module.exports = __webpack_public_path__ + "img/Group 1171@2x.db1e9357.png";